import React from 'react';
const IconMiscGraphBoxFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 21H21V3H3V21ZM15 10H17V17H15V10ZM11 7H13V17H11V7ZM7 13H9V17H7V13Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconMiscGraphBoxFill;